module.exports = __webpack_public_path__ + "img/3.1d3168ef.jpg";